export const COLOR = ["magenta", "green", "volcano", "orange", "gold", "lime", "red", "cyan", "blue", "geekblue", "purple"];

export const OBJ_COLOR = {
	SUCCESS: "#102F6B",
	SUCCESS_LIGHT: "#102F6B1A",
	INFO: "#11C7D9",
	INFO_LIGHT: "#11C7D91A",
	WARNING: "#FBAE16",
	WARNING_LIGHT: "#FBAE161A",
	DANGER: "#FF4D4F",
	DANGER_LIGHT: "#FF4D4F1A",
	SECONDARY: "#8C8C8C",
	SECONDARY_LIGHT: "#8C8C8C1A",
};

export const PATHS = [
	{
		name: "Questions",
		path: "/admin/questions",
	},
	{
		name: "Users",
		path: "/admin/users",
	},
];

export const JWT_SECRETKEY = process.env.REACT_APP_JWT_SECRETKEY || "";

export const USER_ADMIN = ["99999999", "999999999"];

export const USER_LIST = [...USER_ADMIN, "101721", "102866", "200194", "610865", "613119", "614311", "615316"];

export const LANG = ["vi", "en", "kh", "la", "mm"];
